import React from 'react'
import L from 'react-loadable'
import { Image, Dimmer } from 'semantic-ui-react'

const Loading = () => (
    <Dimmer active>
        <Image src="/assets/images/47tj.gif" style={{ display: "inline", width: '100px' }} />
    </Dimmer>
)

export default opts => L({
    loading: Loading,
    ...opts
})


// WEBPACK FOOTER //
// ./src/features/ui/components/Loadable.js